import SEO from '../../components/SEO';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen pt-20 pb-20 px-4">
      <SEO title="Terms & Conditions" />
      <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-3xl border border-slate-100 shadow-sm">
        <h1 className="text-3xl font-bold text-blue-900 mb-8">Terms & Conditions</h1>
        <div className="prose prose-blue max-w-none text-gray-600 space-y-6">
          <p>Welcome to SSS Home Painting. By accessing our website, you agree to these terms.</p>
          
          <h2 className="text-xl font-bold text-blue-900">Service Quotes</h2>
          <p>
            All quotes provided after site inspection are valid for 15 days. Prices may vary based on material cost fluctuations and surface area measurements.
          </p>

          <h2 className="text-xl font-bold text-blue-900">Payment Terms</h2>
          <p>
            We usually require an advance payment for material procurement, followed by stage-wise payments as the project progresses. Full payment is due upon completion and satisfaction check.
          </p>

          <h2 className="text-xl font-bold text-blue-900">Work Execution</h2>
          <p>
            Clients are requested to provide access to electricity and water required for the work. While we take utmost care, clients should remove or cover valuable items before work begins.
          </p>

          <h2 className="text-xl font-bold text-blue-900">Governing Law</h2>
          <p>
            Any disputes arising shall be subject to the exclusive jurisdiction of the courts in Madurai, Tamil Nadu.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
